<template>
  <div class="sidebar-category-tabs__wrapper">
    <div class="sidebar-category-tabs">
      <button
        v-for="cat in categories"
        :key="cat"
        type="button"
        :class="['category-tab', 'app-focus-ring', { 'is-active': cat === modelValue }]"
        @click="$emit('update:modelValue', cat)">
        {{ t(`crudmanager.categories.${cat}`) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  categories: string[]
  modelValue: string
}>()

defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.sidebar-category-tabs__wrapper {
  padding: 4px 10px 8px;
}

.sidebar-category-tabs {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.body--light .sidebar-category-tabs {
  background: rgba(0, 0, 0, 0.04);
}

.category-tab {
  padding: 2px 0;
  margin: 0;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.45);
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0;
  cursor: pointer;
  white-space: nowrap;
  flex: 0 0 auto;
  font-family: inherit;
  text-align: left;
  appearance: none;
  -webkit-appearance: none;
  transition: color 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    color: rgba(255, 255, 255, 0.85);
  }

  &.is-active {
    color: #ffffff;
    font-weight: 600;
  }
}

.body--light .category-tab {
  color: rgba(0, 0, 0, 0.45);

  &:hover {
    color: rgba(0, 0, 0, 0.85);
  }

  &.is-active {
    color: #0f1419;
  }
}
</style>
